import * as React from "react";
const SvgApps = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M4 2v2H2V2Zm1-1H1v4h4Zm4 1v2H7V2Zm1-1H6v4h4Zm4 1v2h-2V2Zm1-1h-4v4h4ZM4 7v2H2V7Zm1-1H1v4h4Zm4 1v2H7V7Zm1-1H6v4h4Zm4 1v2h-2V7Zm1-1h-4v4h4ZM4 12v2H2v-2Zm1-1H1v4h4Zm4 1v2H7v-2Zm1-1H6v4h4Zm4 1v2h-2v-2Zm1-1h-4v4h4Z", fill: "currentColor" }),
    React.createElement("path", { d: "M0 0h16v16H0Z", fill: "none" })));
export default SvgApps;
